/**
 * OAuth2 API client functions.
 */
import { getApiUrl } from '../config/runtime';

/**
 * Initiate OAuth2 login by redirecting to backend authorize endpoint.
 */
export const initiateOAuth2Login = (): void => {
  const apiUrl = getApiUrl();
  const baseUrl = apiUrl.endsWith('/api') ? apiUrl : `${apiUrl}/api`;
  window.location.href = `${baseUrl}/auth/oauth2/authorize`;
};

